import { useEffect, useState } from 'react'
import { PayPalButtons, usePayPalScriptReducer } from '@paypal/react-paypal-js'

const ButtonWrapper = ({
  currency,
  showSpinner,
  style,
  amount,
  handlePaypal,
}) => {
  const [{ options, isPending }, dispatch] = usePayPalScriptReducer()

  useEffect(() => {
    dispatch({
      type: 'resetOptions',
      value: {
        ...options,
        currency: currency,
      },
    })
  }, [currency, showSpinner])

  return (
    <>
      {showSpinner && isPending && <div className="spinner" />}

      <PayPalButtons
        style={style}
        disabled={false}
        forceReRender={[amount, currency, style]}
        fundingSource={undefined}
        createOrder={(data, actions) => {
          return actions.order
            .create({
              purchase_units: [
                {
                  amount: {
                    currency_code: currency,
                    value: amount,
                  },
                },
              ],
            })
            .then((orderId) => {
              const stop = 0
              return orderId
            })
        }}
        onApprove={(data, actions) => {
          return actions.order.capture().then((details) => {
            handlePaypal(1)
          })
        }}
        onCancel={(data, actions) => {
          handlePaypal(0)
        }}
      />
    </>
  )
}

export default ButtonWrapper
